import Button from './ui/Button';
import Input from './ui/Input';
import locales from '../locales.json';

const { EMAIL_TEXTS, COMMON_TEXTS } = locales;

const EmailForm = ({ email, error, loading, onChange, onSubmit, onBack }) => (
  <form className="sheet email" onSubmit={onSubmit} noValidate>
    <h2 className="sheet__eyebrow">{EMAIL_TEXTS.section}</h2>
    <h1 className="sheet__title">{EMAIL_TEXTS.title}</h1>

    <div className="sheet__cols email__field">
      <Input
        id="email"
        type="email"
        inputMode="email"
        autoComplete="email"
        autoFocus
        size="large"
        label={EMAIL_TEXTS.label}
        placeholder={EMAIL_TEXTS.placeholder}
        required
        value={email}
        onChange={onChange}
        error={error}
        disabled={loading}
      />
    </div>

    <p className="sheet__body">{EMAIL_TEXTS.note}</p>

    <div className="sheet__actions">
      <Button variant="ghost" block disabled={loading} onClick={onBack}>
        {COMMON_TEXTS.back}
      </Button>
      <Button variant="primary" block type="submit" loading={loading}>
        {loading ? COMMON_TEXTS.verifying : EMAIL_TEXTS.submit}
      </Button>
    </div>
  </form>
);

export default EmailForm;
